export class Payments {
    static moduleName = 'payments';
    static listTitle = 'Список платежей';
    static apiPrefix = '/payments';
}